import accessPlugin from '@yam-plugin/core-access'
import configPlugin from '@yam-plugin/core-config'
import deployPlugin from '@yam-plugin/core-deploy'
import observePlugin from '@yam-plugin/core-observe'
import scalePlugin from '@yam-plugin/core-scale'
import redisPlugin from '@yam-plugin/redis-provisioner'
import certManagerPlugin from '@yam-plugin/cert-manager'
import helmPlugin from '@yam-plugin/helm-operator'
import apisixPlugin from '@yam-plugin/ingress-apisix'
import golangExamplePlugin from '@yam-plugin/golang-example'
import { PluginDefinition } from 'yam-types'

async function builtInPlugins(): Promise<PluginDefinition<unknown>[]> {
    return [
        certManagerPlugin, helmPlugin, configPlugin, deployPlugin, accessPlugin, apisixPlugin, observePlugin, scalePlugin, redisPlugin,
        await golangExamplePlugin()
    ]
}

export default async function (): Promise<PluginDefinition<unknown>[]> {
    let plugins: PluginDefinition<unknown>[] = []
    if (plugins.length === 0) {
        plugins = await builtInPlugins()
    }
    return plugins
}
